import { action, computed, observable, runInAction } from "mobx";
import { api } from "../../api";
import { IEmpresaNotaManual } from "../../model";
import { toast } from "react-toastify";

export class _NotasStore {
  obs = observable({
    empresasAtrasadasManual: [] as IEmpresaNotaManual[],
    result_ok: false as boolean,
    openModal: true as boolean,
    total_notas: 0 as number,
    prev_total_notas: 0 as number
  })

  @action
  async loadAtrasadasManual(): Promise<void> {
    try {
      let resp = await api.get("/api/empresas-atrasadas-manual");

      if (Array.isArray(resp.data)) {
        this.obs.empresasAtrasadasManual = resp.data;
      } else {
        this.obs.empresasAtrasadasManual = [];
      }
    } catch (ex) {
      toast.error("Erro ao carregar Empresas Atrasadas Manual, tente novamente mais tarde.", {});
    }
  }

  @action
  async deleteNotasManual(): Promise<void> {
    try {
      this.obs.result_ok = false;

      let resp = await api.delete("/api/empresas-atrasadas-manual");

      if (resp.data == "ok") {
        this.obs.result_ok = true;
      }
    } catch (ex) {
      toast.error("Erro ao deletar Empresas Atrasadas Manual, tente novamente mais tarde.", {});
    }
  }

  async handleTotalNotas(data: any) {

    try {

      let resp = await api.post("/api/total-notas", data);

      this.obs.total_notas = 0

      if(resp.data.ok) {

        this.obs.total_notas = resp.data.total

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Erro ao consular total de notas.", {});

    }
  }

}

export const NotasStore = new _NotasStore();
